import { View } from 'react-native';

import { Text } from '@/components/ui/Text';

export interface PlanFeatureRowProps {
  label: string;
  /** Right-aligned annotation, e.g. "FREE · 2". */
  annotation?: string;
}

export function PlanFeatureRow({ label, annotation }: PlanFeatureRowProps) {
  return (
    <View className="flex-row items-center justify-between py-2">
      <Text variant="bodyMedium" className="flex-1">
        {label}
      </Text>
      {annotation ? (
        <Text
          variant="none"
          className="font-accent text-xs uppercase tracking-[0.1em] text-faint"
        >
          {annotation}
        </Text>
      ) : null}
    </View>
  );
}
